import { Trans, useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import LandingCtaButton from '~/landingV4/components/LandingCtaButton'
import QuizRow from '~/landingV4/components/QuizRow'
import SectionContainer from '~/landingV4/components/SectionContainer'
import { quizRows } from '~/landingV4/consts/quizRows.const'
import { AppLanguage } from '~/types/locale'

export default function QuizSection(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const router = useRouter()
  const localePrefix = router.locale === AppLanguage.NO ? 'no/' : ''

  return (
    <SectionContainer className="flex flex-col gap-12 py-16 md:gap-20 md:py-24">
      <div className="mx-auto flex max-w-180 flex-col gap-4 text-center">
        <h2 className="text-h3 font-bold leading-tight text-purple-darker md:text-h2">{t('v4.quiz.title')}</h2>
        <p className="text-md leading-relaxed text-purple-darker">
          <Trans
            components={{ hand: <span className="font-hand text-[26px] whitespace-nowrap text-purple" /> }}
            i18nKey="v4.quiz.subtitle"
            t={t}
          />
        </p>
      </div>

      <div className="flex flex-col gap-16 md:gap-24">
        {quizRows.map((config) => (
          <QuizRow
            config={config}
            imageSrc={`landing/v4/quiz/${localePrefix}${config.imageName}`}
            key={config.stepNumber}
          />
        ))}
      </div>

      <div className="flex justify-center">
        <LandingCtaButton analyticsLabel="landing_v4_quiz_cta" uppercase>
          {t('v4.quiz.cta')}
        </LandingCtaButton>
      </div>
    </SectionContainer>
  )
}
